function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
import URI from 'urijs';
import Result from './result';
/**
 * Collection of results for both presenters and participants. For presenters,
 * fetches all submitted results for the activity this collection belongs to.
 * For participants, fetches all results they have submitted.
 */

var Results = /*#__PURE__*/function (_Backbone$Collection) {
  _inheritsLoose(Results, _Backbone$Collection);

  function Results() {
    return _Backbone$Collection.apply(this, arguments) || this;
  }

  var _proto = Results.prototype;
  /**
   * @param {Array} models Array of result models or datasets to initially add.
   * @param {Object} options
   * @param {Poll} options.poll Activity model this collection belongs to.
   * @param {string} options.source Metadata about where results come from.
   */

  _proto.initialize = function initialize(models, options) {
    if (options === void 0) {
      options = {};
    }
    /**
     * TODO(shared): Rename this property to `activity` and update all consuming
     * repos to stop using `poll` because results are associated to both polls
     * and surveys. The word poll is misleading.
     *
     * Holds reference to the parent activity associated with these results.
     * Can be poll or MQA models (e.g. survey).
     * @type {Backbone.Model}
     */


    this.poll = options.poll;
    /**
     * Metadata to send when saving batch results as a single request. See docs:
     * https://ci.ops.pe/browse/RA-REDOC/latest/artifact/JOB1/Site/ci.html#tag/Participant::BatchResults
     * @type {string}
     */

    this.source = options.source;
  };

  _proto.comparator = function comparator(result) {
    return -result.id;
  }
  /**
   * Returns the results collection endpoint where participant results for the
   * associated activity is fetched and/or created, updated or deleted.
   * @type {string}
   */
  ;

  _proto.url = function url() {
    if (!this.poll) {
      throw new Error('Results collection must be associated to an activity');
    }

    return URI(this.poll.url()).segment('results').toString();
  }
  /**
   * Saves all new results as a single request. Requires all result models to be
   * associated with a participant poll instance with valid participant keys.
   * @return {Promise}
   */
  ;

  _proto.save = function save() {
    var _this = this;

    if (!this.poll || this.poll.type() !== 'survey') {
      throw new Error("Invalid activity type => " + this.poll.type() + "\n" + 'Results must belong to a `survey` to save multiple results');
    } // Only send data for new results.


    var newResults = this.filter(function (result) {
      return result.isNew();
    });
    var data = newResults.map(function (result) {
      // Tack on additional poll data required by the endpoint.
      var datum = Object.assign(result.toJSON(), {
        participant_key: result.poll().get('participant_key'),
        activity_type: result.poll().type()
      }); // Set source if it exists.

      if (_this.source) {
        datum.source = _this.source;
      }

      return datum;
    });
    return Backbone.ajax({
      url: this.url(),
      contentType: 'application/json',
      type: 'post',
      data: JSON.stringify(data)
    });
  }
  /**
   * Clone collection and all its internal results.
   * @param {boolean} cloneChildren When true, also clone child models
   * @return {Results}
   */
  ;

  _proto.clone = function clone(cloneChildren) {
    var clone = _Backbone$Collection.prototype.clone.call(this);

    clone.poll = this.poll;

    if (cloneChildren) {
      clone.reset(clone.map(function (result) {
        return result.attributes;
      }));
    }

    return clone;
  };

  _createClass(Results, [{
    key: "model",
    get: function get() {
      return Result;
    }
  }]);

  return Results;
}(Backbone.Collection);

export { Results as default };